import { render, staticRenderFns } from "./Deposits.vue?vue&type=template&id=4ec76aed&scoped=true&lang=pug"
import script from "./Deposits.vue?vue&type=script&lang=js"
export * from "./Deposits.vue?vue&type=script&lang=js"
import style0 from "./Deposits.vue?vue&type=style&index=0&id=4ec76aed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ec76aed",
  null
  
)

export default component.exports